import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import { getAuthToken } from '../utils/auth';
import './SubscriptionPaywall.css';

export default function SubscriptionPaywall({ children, featureKey }) {
    const [status, setStatus] = useState('loading'); // 'loading', 'active', 'inactive'
    const token = getAuthToken();

    useEffect(() => {
        if (!token) {
            setStatus('inactive');
            return;
        }

        const checkStatus = async () => {
            try {
                const statusEndpoint = featureKey
                    ? API_ENDPOINTS.SUBSCRIPTION.STATUS_FOR_FEATURE(featureKey)
                    : API_ENDPOINTS.SUBSCRIPTION.STATUS;
                const res = await axios.get(statusEndpoint, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (res.data.active) {
                    setStatus('active');
                } else {
                    setStatus('inactive');
                }
            } catch (err) {
                console.error("Failed to check subscription:", err);
                setStatus('inactive');
            }
        };

        checkStatus();
    }, [token, featureKey]);

    if (status === 'loading') {
        return (
            <div className="paywall-loader-wrapper flex flex-col items-center justify-center min-h-[400px] gap-[15px] text-[var(--text-color,#333)]">
                <div className="paywall-loader w-[40px] h-[40px] border-[3px] border-[rgba(0,0,0,0.1)] border-t-[#6366f1] rounded-full animate-spin"></div>
                <p>Checking subscription...</p>
            </div>
        );
    }

    if (status === 'active') {
        return <>{children}</>;
    }

    // Render paywall
    return (
        <div className="paywall-overlay relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden bg-[var(--bg-color,#f8f9fa)]">
            <div className="paywall-content-behind absolute top-0 left-0 w-full h-full z-[1]" style={{filter: 'blur(8px)', opacity: 0.4, pointerEvents: 'none'}}>
                {children}
            </div>

            <div className="paywall-modal bg-white shadow-[0_20px_40px_rgba(0,0,0,0.1),0_0_0_1px_rgba(0,0,0,0.05)] rounded-[20px] p-[40px] max-w-[480px] w-[90%] z-[10] relative text-center flex flex-col items-center" style={{animation: 'slideUp 0.5s ease'}}>
                <div className="paywall-icon-wrap w-[70px] h-[70px] bg-gradient-to-br from-[#6366f1] to-[#a855f7] rounded-[20px] flex items-center justify-center mb-[25px] text-white text-[30px] shadow-[0_10px_20px_rgba(99,102,241,0.3)]">
                    <i className="fi fi-sr-gem"></i>
                </div>
                <h2 className="m-0 mb-[10px] text-[26px] text-[#1a1a1a] font-[700]">Unlock Premium Apps</h2>
                <p className="paywall-subtitle text-[#666] m-0 mb-[30px] leading-[1.5] text-[15px]">
                    Get unlimited access to all AI tools, premium apps, and exclusive content.
                </p>

                <ul className="paywall-features list-none p-0 m-0 mb-[30px] text-left w-full">
                    <li className="flex items-center gap-[12px] mb-[12px] text-[#444] text-[15px]"><i className="fi fi-rr-check-circle text-[#6366f1] text-[18px]"></i> Pomodoro focus timer</li>
                    <li className="flex items-center gap-[12px] mb-[12px] text-[#444] text-[15px]"><i className="fi fi-rr-check-circle text-[#6366f1] text-[18px]"></i> Typewriting practice tests</li>
                    <li className="flex items-center gap-[12px] mb-[12px] text-[#444] text-[15px]"><i className="fi fi-rr-check-circle text-[#6366f1] text-[18px]"></i> Priority support and no ads</li>
                </ul>

                <div className="paywall-price text-[40px] font-[800] text-[#1a1a1a] mb-[25px] flex items-baseline justify-center gap-[4px]">
                    <span className="cur text-[20px] text-[#666] font-[600]">₹</span>1500<span className="freq text-[16px] text-[#888] font-[500]">/month</span>
                </div>

                <a href="/subscription" className="paywall-btn w-full bg-gradient-to-br from-[#111] to-[#333] text-white border-none p-[16px] rounded-[12px] text-[16px] font-[600] cursor-pointer transition-all duration-200 shadow-[0_8px_16px_rgba(0,0,0,0.15)] no-underline inline-flex items-center justify-center hover:translate-y-[-2px] hover:shadow-[0_12px_20px_rgba(0,0,0,0.2)]" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                    View Plans
                </a>
                <div className="paywall-footer mt-[20px] text-[13px] text-[#aaa]">
                    Secured by Razorpay. Cancel anytime.
                </div>
            </div>
        </div>
    );
}
